module.exports = __webpack_public_path__ + "square.4c9c2ccbdc61d8fb8a3603b91e952d49.cache.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/square.svg
// module id = 627
// module chunks = 0